import { useQuery } from "@tanstack/react-query";

import { yetakchiAiAPI } from "../api/yetakchiAiAPI";
import { YetakchiAICacheKey } from "../constants/queryKeys";

export const useChats = () => {
  return useQuery({
    queryKey: [YetakchiAICacheKey, "chats"],
    queryFn: () => yetakchiAiAPI.getChats(),
  });
};
